import React, { createContext, type ReactNode, useContext } from 'react';

import { type useReactRouterAdapter } from '../hooks/useReactRouterAdapter';

type useReactRouterAdapterReturn = ReturnType<typeof useReactRouterAdapter>;

const NavigationContextProvider = createContext<
  useReactRouterAdapterReturn | undefined
>(undefined);

export interface NavigationProviderProps {
  children: ReactNode;
  adapter?: useReactRouterAdapterReturn;
}

export const NavigationContext: React.FC<NavigationProviderProps> = ({
  children,
  adapter,
}) => {
  return (
    <NavigationContextProvider.Provider value={adapter}>
      {children}
    </NavigationContextProvider.Provider>
  );
};

export const useNavigationContext = (): useReactRouterAdapterReturn => {
  const context = useContext(NavigationContextProvider);
  if (!context) {
    throw new Error(
      'useNavigationContext must be used within a NavigationContext',
    );
  }
  return context;
};
